import vectorImg from "../../assets/Vector.png";

export const NAVBAR_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700&family=Jost:wght@300;400;500;600;700&display=swap');

  :root {
    --cor-fundo:        #F7EADB;
    --cor-texto:        #3C3E71;
    --cor-destaque:     #CA481E;
    --cor-linha:        #E8E0D6;
    --fonte-titulo:     var(--font-title, 'Cormorant Garamond', serif);
    --fonte-corpo:      var(--font-body, 'Jost', sans-serif);
    --altura-nav:       72px;
    --transicao:        0.35s cubic-bezier(0.4, 0, 0.2, 1);
  }

  @layer base {
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    html { scroll-behavior: smooth; }
    body { font-family: var(--fonte-corpo); background: var(--cor-fundo); color: var(--cor-texto); }
  }

  .nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    height: var(--altura-nav);
    display: flex;
    align-items: center;
    padding: 0 40px;
    transition: background var(--transicao), box-shadow var(--transicao), border-color var(--transicao);
    background: transparent;
    border-bottom: 1px solid transparent;
  }

  .nav--rolou {
    background: rgba(250, 248, 245, 0.96);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    box-shadow: 0 1px 24px rgba(26,23,20,0.06);
    border-bottom: 1px solid var(--cor-linha);
  }

  .nav__logo {
    display: flex;
    flex-direction: column;
    line-height: 1;
    text-decoration: none;
    color: var(--cor-texto);
    cursor: pointer;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
  }
  .nav__logo-nome {
    font-family: var(--fonte-titulo);
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: var(--cor-texto);
  }
  .nav__logo-img {
    height: 50px;
    width: auto;
    object-fit: contain;
    transition: all var(--transicao);
  }
  .nav__logo-img:hover {
    opacity: 0.8;
  }

  .nav__links {
    display: flex;
    align-items: center;
    gap: 36px;
    list-style: none;
    margin-left: auto;
  }
  .nav__link {
    font-family: var(--fonte-corpo);
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    text-decoration: none;
    color: var(--cor-texto);
    position: relative;
    padding: 10px 22px;
    border-radius: 24px;
    transition: all var(--transicao);
    background: transparent;
  }
  
  .nav__link:hover {
    background: #3C3E71;
    color: white;
    position: relative;
  }
  .nav__link:hover::after {
    content: '';
    display: block;
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 72px;
    height: 18px;
    background-image: url('${vectorImg}');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .nav__link--active {
    background: #3C3E71;
    color: white;
    position: relative;
  }
  .nav__link--active::after {
    content: '';
    display: block;
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 72px;
    height: 18px;
    background-image: url('${vectorImg}');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .nav__cta {
    margin-left: 32px;
    padding: 11px 28px;
    font-family: var(--fonte-corpo);
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
    text-decoration: none;
    color: white;
    border: 1px solid transparent;
    cursor: pointer;
    transition: background var(--transicao), color var(--transicao);
    border-radius: 24px;
  }
  
  .nav__cta--orange {
    background: #BB4B23;
    color: white;
  }
  
  .nav__cta--orange:hover {
    background: #9A3D1B;
  }

  .nav__hamburguer {
    display: none;
    flex-direction: column;
    justify-content: space-between;
    width: 28px;
    height: 18px;
    cursor: pointer;
    background: none;
    border: none;
    margin-left: auto;
    padding: 0;
  }
  .nav__hamburguer span {
    display: block;
    height: 1.5px;
    background: var(--cor-texto);
    transition: transform var(--transicao), opacity var(--transicao), width var(--transicao);
    transform-origin: left center;
  }
  .nav__hamburguer--aberto span:nth-child(1) { transform: rotate(42deg) translateY(-1px); }
  .nav__hamburguer--aberto span:nth-child(2) { opacity: 0; width: 0; }
  .nav__hamburguer--aberto span:nth-child(3) { transform: rotate(-42deg) translateY(1px); }

  .nav__mobile {
    position: fixed;
    top: var(--altura-nav);
    left: 0; 
    right: 0;
    background: var(--cor-fundo);
    border-top: 1px solid var(--cor-linha);
    padding: 32px 40px;
    display: flex;
    flex-direction: column;
    gap: 0;
    z-index: 1001;
    max-height: calc(100vh - var(--altura-nav));
    overflow-y: auto;
    max-width: 100%;
    box-shadow: 0 4px 12px rgba(26, 23, 20, 0.08);
    transform: translateY(-100%);
    opacity: 0;
    pointer-events: none;
    transition: transform var(--transicao), opacity var(--transicao);
    will-change: transform, opacity;
  }
  .nav__mobile--aberto {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }
  .nav__mobile-link {
    font-family: var(--fonte-corpo);
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    text-decoration: none;
    color: var(--cor-texto);
    padding: 12px 16px;
    margin: 8px 0;
    border-radius: 8px;
    border-bottom: none;
    transition: all var(--transicao);
    background: transparent;
  }
  .nav__mobile-link:last-of-type { 
    margin-bottom: 0;
  }
  .nav__mobile-link:hover,
  .nav__mobile-link--active {
    background: #3C3E71;
    color: white;
  }
  .nav__mobile-cta {
    margin-top: 28px;
    padding: 12px 20px;
    font-family: var(--fonte-corpo);
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
    text-decoration: none;
    color: white;
    background: #CA481E;
    text-align: center;
    cursor: pointer;
    transition: all var(--transicao);
    border-radius: 8px;
    border: 1px solid transparent;
    display: inline-block;
  }
  .nav__mobile-cta:hover { 
    background: #9A3D1B;
  }

  @media (max-width: 1104px) {
    .nav { padding: 0 24px; }
    .nav__links { display: none; }
    .nav__cta    { display: none; }
    .nav__hamburguer { display: flex; }
  }
`;